// eslint-disable-next-line no-restricted-imports
import {defaultStyles} from '@styles/index';

export default defaultStyles.overflowAuto;
